import { Edit, Trash2 } from "lucide-react";
import Button from "../ui/Button";

export default function DomainItem({ domain, onEdit, onDelete }) {
  return (
<div key={domain?.id} className="webhook-box">


<a
  href={domain?.domain}
  target="_blank"
  rel="noopener noreferrer"
  className="webhook-url"
>
  {domain?.domain}
</a>

<div className="webhook-actions">
  <Button variant="plain" onClick={() => onEdit()}>
    <Edit size={14} className="text-slate-600" />
  </Button>
  <Button
    variant="plain"
    onClick={() => onDelete()}
  >
    <Trash2 size={14} className="text-danger" />
  </Button>
</div>
</div>
  );
}

